import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "GroupSharedActions" */ "./lazyIndex"), { name: "GroupSharedActions" });

export const lazyLoadGroupAction: LazyAction<typeof lazyIndex.loadGroupAction, typeof lazyModule> = new LazyAction(lazyModule, m => m.loadGroupAction);

export const lazyOnAfterNewGroupSelected: LazyAction<typeof lazyIndex.onAfterNewGroupSelectedAction, typeof lazyModule> = new LazyAction(lazyModule, m => m.onAfterNewGroupSelectedAction);

export const lazyOnAfterGroupDetailsSucceeded: LazyAction<typeof lazyIndex.onAfterGroupDetailsSucceededAction, typeof lazyModule> = new LazyAction(lazyModule, m => m.onAfterGroupDetailsSucceededAction);

export const lazySetGroupIsSubscribed: LazyAction<typeof lazyIndex.setGroupIsSubscribedAction, typeof lazyModule> = new LazyAction(lazyModule, m => m.setGroupIsSubscribedAction);

export const lazySetGroupIsMember: LazyAction<typeof lazyIndex.setGroupIsMemberAction, typeof lazyModule> = new LazyAction(lazyModule, m => m.setGroupIsMemberAction);
